import React from 'react'
import { Field } from 'redux-form'
import { connect } from 'react-redux'
import { actualizarDropdown } from '../actions/DropdownActions'
import { renderSelectFieldWithOptions } from '../../../../Forms/fieldRenderers'

class DropdownEtiqueta extends React.Component {
  componentDidUpdate (prevProps) {
    if (this.props.cereal !== undefined && this.props.cerealVariedad !== undefined && (this.props.cereal !== prevProps.cereal || this.props.cerealVariedad !== prevProps.cerealVariedad)) {
      this.props.actualizarDropdown(this.props.cereal, this.props.cerealVariedad)
    }
  }

  render () {
    return (
      <Field name='etiqueta' label='Etiqueta' placeholder='Etiqueta' options={this.props.etiquetas} component={renderSelectFieldWithOptions} type='text' />
    )
  }
}

const mapStateToProps = (state) => ({
  etiquetas: state.dropdownEtiqueta.etiquetas,
  cereal: state.dropdownEtiqueta.cereal,
  cerealVariedad: state.dropdownEtiqueta.cerealVariedad
})
const mapDispatchToProps = { actualizarDropdown }

export default connect(mapStateToProps, mapDispatchToProps)(
  DropdownEtiqueta
)
